import React, { type ReactNode, useId } from 'react';

import StdDialogTitle from 'components/Dialogs/StdDialogTitle';

import DrawerDialogSurface from './DrawerDialogSurface';

type TitleProps = React.ComponentProps<typeof StdDialogTitle>;

type Props = {
  children: ReactNode;
  onBack?: TitleProps['onBack'];
  onClose: TitleProps['onClose'];
  showBackButton?: boolean;
  showCloseButton?: boolean;
  title: ReactNode;
};

export default function DrawerDialogFrame({
  children,
  onBack,
  onClose,
  showBackButton = false,
  showCloseButton = true,
  title,
}: Props): React.JSX.Element {
  const titleId = useId();

  return (
    <DrawerDialogSurface labelledBy={titleId}>
      <StdDialogTitle
        variant='drawer'
        id={titleId}
        onBack={onBack}
        onClose={onClose}
        showBackButton={showBackButton}
        showCloseButton={showCloseButton}
      >
        {title}
      </StdDialogTitle>
      {children}
    </DrawerDialogSurface>
  );
}
